import React from 'react';

import {TabbedForm} from 'components/@common/widgets/tabbed-form';
import {Changelog} from 'components/@common/widgets/tabbed-form/common-tabs/changelog';
import {IChangelogEntity} from 'components/@common/widgets/tabbed-form/common-tabs/changelog/changelog.types';
import {
    ETCFileExchangeTabs,
    ETCFileExchangeTabTitles,
    TCNotFoundMessage,
} from 'components/ais/transport-container-card/constants/transport-container-card.contants';
import {TransportContainerInformation} from 'components/ais/transport-container-card/tabs/transport-container-information/transport-container-information';
import {useGetTransportContainerQuery} from 'store/api/transport-container/transport-container.api';

import './transport-container-card.less';

export interface ITransportContainerCardProps {
    id: string;
    entityName: string;
}

export const TransportContainerCard = ({
    id,
    entityName,
}: ITransportContainerCardProps) => {
    const {
        data: transportContainer,
        isLoading,
    } = useGetTransportContainerQuery({id}, {skip: !id});

    const changelogData: IChangelogEntity[] | undefined = transportContainer?.audits?.map(a => ({
        id: a.id,
        stage: a.stage,
        statusCode: a.statusCode,
        statusText: a.statusText,
        createdDate: a.createdDate,
        updatedDate: a.updatedDate,
    }));

    return (
        <TabbedForm
            classNames={{
                tabsWrapper: 'transport-container-card',
            }}
            title={transportContainer ? `Карточка ${transportContainer.name}` : ' '}
            defaultTabKey={ETCFileExchangeTabs.main}
            isLoading={isLoading}
            modalWrapped
            emptyProps={{
                isEmpty: !transportContainer,
                description: TCNotFoundMessage,
            }}
            tabs={transportContainer && (
                [
                    {
                        key: ETCFileExchangeTabs.main,
                        title: ETCFileExchangeTabTitles.main,
                        content: (
                            <TransportContainerInformation
                                transportContainerId={id}
                                transportContainer={transportContainer}
                                entityName={entityName}
                            />
                        ),
                    },
                    {
                        key: ETCFileExchangeTabs.changes,
                        title: ETCFileExchangeTabTitles.changes,
                        content: changelogData && (
                            <Changelog
                                changelogData={changelogData}
                            />
                        ),
                    },
                ]
            )}
        />
    );
};
